'use client';

import { c as _c } from "react/compiler-runtime";
import { SvgAdd, SvgMinus, SvgTrash } from '@common/icon';
import { cn } from '@core/utils';
export interface CartCountProps {
  count: number;
  min?: number;
  max?: number;
  onCountChange?: (count: number) => void;
  onDelete?: () => void;
  className?: string;
}
export const CartCount = t0 => {
  const $ = _c(27);
  const {
    count,
    min: t1,
    max,
    onCountChange,
    onDelete,
    className
  } = t0;
  const min = t1 === undefined ? 1 : t1;
  const isMinReached = count <= min;
  const isMaxReached = max !== undefined && count >= max;
  const showDeleteButton = isMinReached && onDelete;
  let t2;
  if ($[0] !== className) {
    t2 = cn("flex h-36 w-90 items-center justify-center gap-8 overflow-hidden rounded-xsmall border border-Gray-400 bg-Gray-white px-12 mobile-tablet:h-26 mobile-tablet:w-auto mobile-tablet:gap-4 mobile-tablet:px-8", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== count || $[3] !== isMinReached || $[4] !== min || $[5] !== onCountChange || $[6] !== onDelete || $[7] !== showDeleteButton) {
    t3 = showDeleteButton ? <button type="button" onClick={onDelete} aria-label={"\uC0AD\uC81C"} className="size-12 text-Gray-600"><SvgTrash className="size-12" /></button> : <button type="button" onClick={() => onCountChange?.(Math.max(min, count - 1))} aria-label={"\uC218\uB7C9 \uAC10\uC18C"} disabled={isMinReached} className={cn("size-12", isMinReached ? "text-Gray-400" : "text-Gray-900")}><SvgMinus className="size-12" /></button>;
    $[2] = count;
    $[3] = isMinReached;
    $[4] = min;
    $[5] = onCountChange;
    $[6] = onDelete;
    $[7] = showDeleteButton;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== count) {
    t4 = <span className="min-w-20 text-center font-400 text-Gray-black typo-body4 mobile-tablet:typo-caption1">{count}</span>;
    $[9] = count;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== count || $[12] !== max || $[13] !== onCountChange) {
    t5 = () => onCountChange?.(Math.min(max ?? Infinity, count + 1));
    $[11] = count;
    $[12] = max;
    $[13] = onCountChange;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const t6 = isMaxReached ? "text-Gray-400" : "text-Gray-900";
  let t7;
  if ($[15] !== t6) {
    t7 = cn("size-12", t6);
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <SvgAdd className="size-12" />;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== isMaxReached || $[19] !== t5 || $[20] !== t7) {
    t9 = <button type="button" onClick={t5} aria-label={"\uC218\uB7C9 \uC99D\uAC00"} disabled={isMaxReached} className={t7}>{t8}</button>;
    $[18] = isMaxReached;
    $[19] = t5;
    $[20] = t7;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t2 || $[23] !== t3 || $[24] !== t4 || $[25] !== t9) {
    t10 = <div className={t2}>{t3}{t4}{t9}</div>;
    $[22] = t2;
    $[23] = t3;
    $[24] = t4;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  return t10;
};